module.exports = __webpack_public_path__ + "r-v3/img/ico_triangle_down_white.3c25f450.png";